// This is super ugly but the quickest solution I have in mind for nested obj in the form
// to enalbe form field error messages to be shown
export const splitFieldName = (name: string) => {
  const splittedFieldName = name.split(".");
  return {
    firstPart: splittedFieldName[0],
    secondPart: splittedFieldName[1],
  };
};
